import EngagementClaimModalComponent from './engagement-claim-modal.component'

const EngagementClaimModalModule = angular.module('cdbl.engagement-claim-modal', [

])
  .component('cdblEngagementClaimModal', EngagementClaimModalComponent)
  .name

export default EngagementClaimModalModule
